import { render, staticRenderFns } from "./setting_change_log.vue?vue&type=template&id=782b629e&scoped=true"
import script from "./setting_change_log.vue?vue&type=script&lang=js"
export * from "./setting_change_log.vue?vue&type=script&lang=js"
import style0 from "./setting_change_log.vue?vue&type=style&index=0&id=782b629e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b629e",
  null
  
)

export default component.exports